"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const urlBuilderTools_1 = require("./urlBuilderTools");
/**
 * Returns a function that creates URL strings. The function is configured to use the provided baseUrl.
 *
 * The returned function takes a relative path which can optionally include search parameters.
 *
 * @param baseUrl The returned function uses this as a base for URL's it creates
 */
const getUrlGenerator = (baseUrl) => (relative) => {
    if (typeof relative === "string") {
        return (0, urlBuilderTools_1.buildUrl)(baseUrl, [relative]).toString();
    }
    const { pathname, search } = relative;
    const url = (0, urlBuilderTools_1.buildUrl)(baseUrl, [pathname]);
    if (typeof search === "string") {
        url.search = new URLSearchParams(search).toString();
        return url.toString();
    }
    const params = new URLSearchParams();
    Object.entries(search || {}).forEach(([key, value]) => {
        // Arrays need to be added in multiple steps
        if (Array.isArray(value)) {
            value.forEach((v) => params.append(key, String(v)));
        }
        else {
            params.append(key, String(value));
        }
    });
    url.search = params.toString();
    return url.toString();
};
exports.default = getUrlGenerator;
